import { constants } from "../../constants";

export const toggleModal = () => {
    return { type: constants.TOGGLE_ACTION };
};
